<template>
    <div class="col-sm-12 nopads">
        <div class="px-1">
            <div class="col-sm-12 search-form-title">
                <font-awesome-icon icon="search" />
                {{ $t('common.search') }}
            </div>
            <div>
                <div class="row mb-4">
                    <div class="col-sm-4">
                        <span class="search-title">{{ $t('ins_report.from_date') }}</span>
                        <input
                            id="from_date"
                            v-model="fromDate"
                            type="date"
                            class="form-control form-control-sm no-margin"
                        />
                    </div>
                    <div class="col-sm-4">
                        <span class="search-title">{{ $t('ins_report.to_date') }}</span>
                        <input
                            id="to_date"
                            v-model="toDate"
                            type="date"
                            class="form-control form-control-sm"
                        />
                    </div>
                    <div class="col-sm-4">
                        <open-contract-filter :from="fromDate" :to="toDate" :contract="contract" :apply-padding="false"
                            :row-view="false" :showOnlyMyContractsOption="true" :show-title="true" :show-company="false"
                            @contractSelected="setContract" />
                    </div>
                </div>
                <div class="col-sm-12 d-flex justify-content-end pt-2 px-2">
                    <button class="btn btn-success form-button" @click.stop="$emit('add')">
                        {{ $t('mvr_inspection.add') }}
                    </button>
                    <button class="btn btn-danger form-button" @click.stop="onResetSearch">
                        {{ $t('ins_report.clear') }}
                    </button>
                    <button :disabled="!fromDate" class="btn btn-primary form-button" @click.stop="onSubmitSearch">
                        {{ $t('ins_report.search') }}
                    </button>
                </div>
            </div>
        </div>
        <Transition name="fade">
            <div class="list-container nopads px-1 pb-3 mt-3">
                <div v-if="tableItems.length > 0" class="col-sm-12 list-content result-table">
                    <vue3-datatable
                        ref="resultTable"
                        :rows="tableItems"
                        :columns="fields"
                        :pagination="false"
                        :sticky-header="true"
                        height="100%"
                        :sortable="true"
                        skin="bh-table-compact"
                        row-class="routa-table-row"
                        cell-class="routa-table-cell"
                        @row-click="emitDetails"
                    >
                        <template #total="row">{{ row.value.total }} %</template>
                    </vue3-datatable>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script>
import { inspectionHelper } from '@/components/mixins/InspectionMixin'
import { timeUtils } from '@/components/mixins/TimeUtils'
import OpenContractFilter from "@/components/contract/OpenContractFilter";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'MvrInspectionReportList',
    mixins: [timeUtils, inspectionHelper],
    components: {
        OpenContractFilter,
        Vue3Datatable
    },
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            fromDate: '',
            toDate: '',
            contract: null,
            tableItems: [],
            fields: [
                { field: 'id', title: this.$t('common.id'), sort: true, headerClass: 'routa-table-header', type: 'number' },
                { field: 'created', title: this.$t('ins_report.list_label.created'), sort: true, filterByFormatted: true, headerClass: 'routa-table-header' },
                { field: 'name', title: this.$t('ins_report.list_label.name'), sort: true, filterByFormatted: true, headerClass: 'routa-table-header' },
                { field: 'inspector', title: this.$t('ins_report.list_label.inspector'), sort: true, filterByFormatted: true, headerClass: 'routa-table-header' },
                { field: 'contract', title: this.$t('ins_report.list_label.contract'), sort: true, filterByFormatted: true, headerClass: 'routa-table-header' },
                { field: 'total', title: this.$t('mvr_inspection.inspection_report_details.result'), sort: true, filterByFormatted: true, headerClass: 'routa-table-header', type: 'number' }
            ]
        }
    },
    watch: {
        results() {
            // Conver to table items
            const items = []
            this.results.forEach(item =>
                items.push({
                    'id': item.id,
                    'created': this.toLocalTime(item.created),
                    'name': item.name,
                    'inspector': this.getInspector(item.inspector),
                    'results': item.results,
                    'contract': item.contract ? item.contract.name : '',
                    'total': item.total
                })
            )
            this.tableItems = items
        }
    },
    mounted() {
        if (!this.fromDate) {
            let now = new Date()
            now.setDate(1)
            this.fromDate = this.timestampToDateInput(now.getTime())
        }
    },
    methods: {
        setContract(contract) {
            this.contract = contract
        },
        onResetSearch() {
            this.fromDate = ''
            this.toDate = ''
            this.contract = null
        },
        onSubmitSearch() {
            var params = {}
            if (this.fromDate !== null && this.fromDate.trim()) {
                params.from = this.localTimeToUtcTime(this.fromDate).toISOString()
            }
            if (this.toDate !== null && this.toDate.trim()) {
                params.to = this.getEndOfTheDay(this.toDate).toISOString()
            }
            if (this.contract) {
                params.contract = this.contract.id
            }
            this.$emit('search', params)
        },
        emitDetails(report) {
            const selectedReport = this.results.find(x => x.id === report.id)
            if(selectedReport) {
                this.$emit('selectedReport', selectedReport)
            }
        }
    }
}
</script>
